import { css, Theme } from "@emotion/react";

export const InputPasswordStyle = {
  self: ({ colors }: Theme) => css`
    &.ant-input-affix-wrapper,
    .ant-input-affix-wrapper {
      width: 100%;
      height: 44px;
      padding: 5px 10px;
      font-size: 14px;
      border-radius: 8px;
      outline: none;
      box-shadow: none;
      font-weight: 500;
    }
    input {
      color: #ffffff80 !important;
    }
    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill:active {
      -webkit-box-shadow: 0 0 0 30px #101520 inset !important;
      -webkit-text-fill-color: #ffffff80 !important;
    }
    input::placeholder {
      color: #ffffff50 !important;
    }
    .ant-input-suffix {
      svg {
        color: #ffffff80;
      }
    }

    & .ant-form-item-explain-error {
      color: var(--error-color) !important;
    }
  `
};
